const create = require("../vendor/qrcode/core/qrcode").create;
const render = require("../vendor/qrcode/renderer/svg-tag").render;

export function qrSvg(text) {
    const code = create(text, { errorCorrectionLevel: "M" });
    return render(code, {
        margin: 1,
        width: 220,
        color: {
            dark: "#111111",
            light: "#ffffff"
        }
    });
}
